import * as types from './types';

const initialState = {
  selectedPostingIsDevelopment: false,
  selectedPostingIndex: null,
  selectedPostingId: null,
  selectedPlanId: null,
  selectedPlanName: '',
  modalNameToShow: '',
  availablePlans: [],
  freemiumPlanId: null,
  hasAvailableItems: false
};

function modalsReducer(state = initialState, action) {
  switch (action.type) {
    case types.UPDATE_MODALS:
      return {
        ...state,
        ...action.payload
      };

    case types.RESET_MODALS:
      return {
        ...state,
        ...initialState
      };

    default:
      return state;
  }
}

export default modalsReducer;
